<script lang="ts">
  export let checked: boolean;
  export let onClicked: ((shiftPressed: boolean) => void) | undefined =
    undefined;
  let disabled = false;
  export let label = "";
  export let customClass = "";
  export let name = "";
  export let onToggle: ((newState: boolean) => void) | null = null;

  const clicked = (e: MouseEvent) => {
    e.stopPropagation();
    // clicked is called before checked is updated.

    document.getSelection()?.removeAllRanges();
    if (onClicked) {
      onClicked(e.getModifierState("Shift"));
    } else {
      checked = !checked;
      if (onToggle) onToggle(checked);
    }
  };
</script>

<div class="flex items-center {customClass}">
  <input
    type="checkbox"
    {name}
    id={name}
    {checked}
    on:click={clicked}
    {disabled}
    class="custom-checkbox peer"
  />
  <svg
    class="custom-checkmark"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="20 6 10 20 4 12"></polyline>
  </svg>
  {#if label !== ""}
    <label id="checkboxLabel" class="ml-2 text-gray-700 select-none" for={name}>
      {label}
    </label>
  {/if}
</div>

<style lang="postcss">
  .custom-checkbox {
    @apply h-[24px] w-[24px] rounded-[5px] focus:outline-none focus:ring-0
      border-[2px] border-[#c5dedb] accent-[#67908a] appearance-none bg-white
      focus:ring-offset-0 hover:border-[#a4baba] checked:bg-[#67908a]
      checked:border-[#67908a] cursor-pointer bg-transparent text-transparent;
  }
  .custom-checkmark {
    @apply absolute w-[16px] h-[16px] ml-[4px] hidden peer-checked:block
      pointer-events-none;
  }
</style>
